// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__dUx4v","errorLogs":"EditorFooter_errorLogs__Py_-X"};